import { Box } from "@mui/material";

import { Chat } from "./Chat";

export const ChatPage = () => {
  return (
    <Box
      flex={1}
      display="flex"
      flexDirection="column"
      alignItems="stretch"
      minHeight="100%"
      data-testid="hendren-chat-page"
      maxWidth="900px"
      mx="auto"
    >
      <Box flex={1} display="flex" flexDirection="column" alignItems="stretch">
        <Chat />
      </Box>
    </Box>
  );
};
